import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Profile() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/dealer/profile").then(({ data }) => setData(data));
  }, []);
  if (!data) return <div className="text-[#6b655c]">Yükleniyor…</div>;
  const c = data.company;

  return (
    <div className="space-y-6 max-w-4xl" data-testid="dealer-profile-page">
      <div>
        <span className="label-tag">Hesap</span>
        <h1 className="font-serif text-4xl mt-2">Firma Bilgilerim</h1>
        <p className="text-[#6b655c] mt-1">Bu bilgileri admin yönetir. Değişiklik için Evser Halı yetkilisiyle iletişime geçin.</p>
      </div>

      <div className="bg-white border border-[#eae5dc] p-6 space-y-4">
        <h3 className="font-serif text-xl">Firma</h3>
        <Row label="Unvan" value={c.title} />
        <Row label="Kısa Ad" value={c.short_name} />
        <Row label="Yetkili" value={c.contact_person} />
        <Row label="Telefon" value={c.phone} />
        <Row label="E-posta" value={c.email || "—"} />
        <Row label="Vergi Dairesi / No" value={`${c.tax_office || "—"} / ${c.tax_number || "—"}`} />
        <Row label="İl / İlçe" value={`${c.city} / ${c.district}`} />
        <Row label="Adres" value={c.address || "—"} />
      </div>

      <div className="bg-white border border-[#eae5dc] p-6 space-y-3">
        <h3 className="font-serif text-xl">Teslimat Adresleri</h3>
        <div className="border border-[#eae5dc] p-3">
          <div className="text-xs uppercase tracking-wider text-[#c8a97e]">Ana Teslimat</div>
          <p className="text-sm mt-1">{c.main_delivery_address}</p>
        </div>
        {(c.extra_delivery_addresses || []).map((a, i) => (
          <div key={i} className="border border-[#eae5dc] p-3">
            <div className="text-xs uppercase tracking-wider text-[#6b655c]">{a.label}</div>
            <p className="text-sm mt-1">{a.address}</p>
          </div>
        ))}
      </div>

      <div className="bg-white border border-[#eae5dc] p-6">
        <h3 className="font-serif text-xl">Erişim</h3>
        <Row label="Kullanıcı Adı" value={data.user.username} />
      </div>
    </div>
  );
}

const Row = ({ label, value }) => (
  <div className="grid grid-cols-3 gap-3 py-2 border-b border-[#f0ebe2] last:border-0 text-sm">
    <div className="text-xs uppercase tracking-wider text-[#6b655c]">{label}</div>
    <div className="col-span-2">{value}</div>
  </div>
);
